import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import {
  Avatar,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { Switch } from "@progress/kendo-react-inputs";
import AlertBox from "../../components/common/AlertBox";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { MdDelete } from "react-icons/md";

import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import {
  ActiveInactiveGallary,
  deleteGallary,
  getAllGallarys,
} from "./services/gallary.services";
import { clearGallaryID, setGallaryID } from "./gallarySlice";
import ButtonCreate from "../../components/muidrawer/ButtonCreate";
import ButtonEdit from "../../components/muidrawer/ButtonEdit";
import { Tooltip } from "@mui/material";
import { FaGraduationCap } from "react-icons/fa6";

const Gallary: React.FC = () => {
  const dispatch = useAppDispatch();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  // const handleCreate = () => {
  //   navigate("/gallary/create");
  // };

  useEffect(() => {
    dispatch(getAllGallarys());
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  return (
    <>
      <DeleteGallaryDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 0 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Gallary List
          </Typography.h4>
          {isAddAccess && (
            // <Button
            //   onClick={handleCreate}
            //   fillMode={"solid"}
            //   themeColor={"primary"}
            // >
            //   {"Create Gallary"}
            // </Button>
            <ButtonCreate label="Create Gallary" drawerName="gallaryForm" />
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <GallaryGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const GallaryGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const GallaryList = useAppSelector((state) => state.gallary.GallaryList);
  const loading = useAppSelector((state) => state.gallary.loading);

  useEffect(() => {
    dispatch(getAllGallarys());
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All" ? GallaryList.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    // const handleEdit = (ID: number) => {
    //   navigate("/gallary/edit", { state: { GallaryID: ID } });
    // };
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteGallary"));
      dispatch(setGallaryID(ID));
    };

    return (
      <td
        className={`action-td ${props.className}`}
        style={{
          ...props.style,
        }}
      >
        {isEditAccess && (
          // <IconButton
          //   type="button"
          //   fillMode="flat"
          //   size="small"
          //   title="Edit"
          //   onClick={() => handleEdit(props.dataItem.ID)}
          // >
          //   <FiEdit
          //     className="absolute-position"
          //     style={{ fontSize: "20px" }}
          //   />
          // </IconButton>
          <ButtonEdit
            ID={props.dataItem.ID}
            name="gallaryForm"
            tooltipTitle="Edit"
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            themeColor="error"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 2 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const MyActiveInActtiveCommandCell = (props: GridCellProps) => {
    const [IsActive, setIsActive] = useState<boolean>(
      props.dataItem.IsActive ?? false
    );

    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        ID: props.dataItem.ID,
        IsActive: !IsActive,
      };
      dispatch(ActiveInactiveGallary(data)).then((response: any) => {
        // dispatch(getAllGallarys());
        if (response.payload?.data?.Status === 200) {
          dispatch(getAllGallarys());
        } else {
          dispatch(getAllGallarys());
        }
      });
    };

    return (
      <td
        style={{ textAlign: "center", ...props.style }}
        className={props.className}
      >
        <Switch
          disabled={isEditAccess ? false : true}
          name="IsActive"
          checked={IsActive}
          onChange={handleActiveInActive}
          size="small"
        />
      </td>
    );
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {GallaryList && GallaryList.length ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 152px)" }}
          filterable={true}
          filter={filter}
          className="responsive-table"
          data={
            filter
              ? filterBy(GallaryList, filter).slice(
                  page.skip,
                  page.take + page.skip
                )
              : GallaryList.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={GallaryList.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 15, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="ImgAlt"
            title="Gallary Name"
            width={250}
            cell={(props: any) => (
              <td>
                <div className="hoverableName">
                  {isEditAccess ? (
                    <ButtonEdit
                      ID={props.dataItem.ID}
                      name="gallaryForm"
                      label={props.dataItem?.ImgAlt}
                    />
                  ) : (
                    <div className="normalName">{props.dataItem?.ImgAlt}</div>
                  )}
                </div>
              </td>
            )}
          />
          <Column
            field="GallaryImage"
            title="Image"
            width={100}
            filterable={false}
            cell={(props: any) => (
              <td style={{ textAlign: "center" }}>
                <Avatar
                  style={{
                    cursor: "pointer",
                    width: "100%",
                    height: "100%",
                    flexBasis: 45,
                    backgroundColor: "white",
                  }}
                  rounded={"medium"}
                  type={"image"}
                >
                  <Tooltip
                    placement="left"
                    title={
                      <img
                        style={{
                          padding: "5px",
                          backgroundColor: "white",
                          height: 150,
                        }}
                        src={props.dataItem?.GallaryImage}
                        alt="Gallary Image"
                        width="100%"
                        onClick={() =>
                          window.open(props.dataItem?.GallaryImage)
                        }
                      />
                    }
                  >
                    {props.dataItem?.GallaryImage ? (
                      <img
                        style={{ padding: "10px" }}
                        src={props.dataItem?.GallaryImage}
                        alt="Gallary Image"
                        onClick={() =>
                          window.open(props.dataItem?.GallaryImage)
                        }
                      />
                    ) : (
                      <>
                        <FaGraduationCap
                          style={{
                            fontSize: "50px",
                            background: "lightgray",
                            padding: "5px",
                            borderRadius: "4px",
                            color: "#163064",
                          }}
                        />
                      </>
                    )}
                  </Tooltip>
                </Avatar>
              </td>
            )}
          />
          <Column
            field="ID"
            title="Status"
            cell={MyActiveInActtiveCommandCell}
            width={"90px"}
            filterable={false}
            locked={true}
          />
          {(isEditAccess || isDeleteAccess) && (
            <Column
              field="ID"
              title="Actions"
              cell={MyEditCommandCell}
              width={"110px"}
              locked={true}
              filterable={false}
            />
          )}
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

const DeleteGallaryDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const GallaryID = useAppSelector((state) => state.gallary.GallaryID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteGallary(ID));
      if (response.payload.Data.Status === 200) {
        dispatch(getAllGallarys());
        dispatch(closeDialog());
        dispatch(clearGallaryID());
      } else {
        dispatch(getAllGallarys());
        dispatch(closeDialog());
        dispatch(clearGallaryID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteGallary" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Gallary"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this gallary ?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(GallaryID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default Gallary;
